import PropTypes from 'prop-types';
import SectionDivider from 'modules/shared/common/components/SectionDivider';
import { addLabFormValidationErrorType } from 'modules/labs/laboratories/enums';
import InputField from 'modules/shared/common/components/InputField';
import ToggleBtn from 'modules/shared/common/components/ToggleBtn';
import DropdownMenu from 'modules/shared/common/components/DropdownMenu';
import {
  FormWrapper,
  FormGrid,
  FormLabel,
  FormFieldWrapper,
  ActivityFormFieldWrapper,
  FormValidationError,
  extendInputFieldStyle,
  AddOrEditVendorComponentLocationInputsWrapper,
  AddOrEditVendorComponenSingleLocationWrapper,
} from './AddOrEditVendorComponent.style';
// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const AddOrEditVendorComponent = ({
  stringsData,
  formFieldsValues,
  setFormFieldsValues,
  formFieldsValidation,
  vendorTypes,
  handleDropDownFieldChange,
}) => {
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleTextInputFieldChange = (fieldName, fieldEvent) => {
    const { value } = fieldEvent.target;
    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj[fieldName] = value;
      return fieldsObj;
    });
  };

  const handleCheckboxFieldChange = (fieldName, fieldEvent) => {
    const { checked } = fieldEvent.target;
    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj[fieldName] = checked;
      return fieldsObj;
    });
  };

  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <FormWrapper>
      <FormGrid>
        {/* Name */}
        {vendorTypes?.length > 0 && (
          <FormFieldWrapper span={6}>
            <FormLabel>{`${stringsData.vendorDetailsContent.vendorDetailsFormFields.getFormFieldLabel(
              stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.pharmacyType,
            )}*`}</FormLabel>
            <DropdownMenu
              dropdownMenuItemsList={vendorTypes}
              dropdownMenuSelectedObj={vendorTypes.find(
                type => type.id === formFieldsValues.pharmacyTypeId,
              )}
              handleDropdownMenuChange={handleDropDownFieldChange}
              objectMapper={{ key: 'id', name: 'name' }}
            />
            {formFieldsValidation.pharmacyTypeId === addLabFormValidationErrorType.empty && (
              <>
                <SectionDivider gap={4} />
                <FormValidationError>
                  {stringsData.vendorDetailsContent.vendorDetailsFormFields.formEmptyFieldError(
                    stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.pharmacyType,
                  )}
                </FormValidationError>
              </>
            )}
          </FormFieldWrapper>
        )}
        <FormFieldWrapper span={3}>
          <FormLabel>{`${stringsData.vendorDetailsContent.vendorDetailsFormFields.getFormFieldLabel(
            stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.englishName,
          )}*`}</FormLabel>
          <SectionDivider gap={4} />
          <InputField
            type="text"
            value={formFieldsValues.englishName}
            onChange={event =>
              handleTextInputFieldChange(
                stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.englishName,
                event,
              )
            }
            name={stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.englishName}
          />
          {formFieldsValidation.englishName === addLabFormValidationErrorType.empty && (
            <>
              <SectionDivider gap={4} />
              <FormValidationError>
                {stringsData.vendorDetailsContent.vendorDetailsFormFields.formEmptyFieldError(
                  stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.englishName,
                )}
              </FormValidationError>
            </>
          )}
        </FormFieldWrapper>
        <FormFieldWrapper span={3}>
          <FormLabel>{`${stringsData.vendorDetailsContent.vendorDetailsFormFields.getFormFieldLabel(
            stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.arabicName,
          )}*`}</FormLabel>
          <SectionDivider gap={4} />
          <InputField
            type="text"
            value={formFieldsValues.arabicName}
            onChange={event =>
              handleTextInputFieldChange(
                stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.arabicName,
                event,
              )
            }
            name={stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.arabicName}
          />
          {formFieldsValidation.arabicName === addLabFormValidationErrorType.empty && (
            <>
              <SectionDivider gap={4} />
              <FormValidationError>
                {stringsData.vendorDetailsContent.vendorDetailsFormFields.formEmptyFieldError(
                  stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.arabicName,
                )}
              </FormValidationError>
            </>
          )}
        </FormFieldWrapper>
        {/* Display Name */}
        <FormFieldWrapper span={3}>
          <FormLabel>{`${stringsData.vendorDetailsContent.vendorDetailsFormFields.getFormFieldLabel(
            stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.englishDisplayName,
          )}*`}</FormLabel>
          <SectionDivider gap={4} />
          <InputField
            type="text"
            value={formFieldsValues.englishDisplayName}
            onChange={event =>
              handleTextInputFieldChange(
                stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.englishDisplayName,
                event,
              )
            }
            name={stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.englishDisplayName}
          />
          {formFieldsValidation.englishDisplayName === addLabFormValidationErrorType.empty && (
            <>
              <SectionDivider gap={4} />
              <FormValidationError>
                {stringsData.vendorDetailsContent.vendorDetailsFormFields.formEmptyFieldError(
                  stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.englishDisplayName,
                )}
              </FormValidationError>
            </>
          )}
        </FormFieldWrapper>
        <FormFieldWrapper span={3}>
          <FormLabel>{`${stringsData.vendorDetailsContent.vendorDetailsFormFields.getFormFieldLabel(
            stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.arabicDisplayName,
          )}*`}</FormLabel>
          <SectionDivider gap={4} />
          <InputField
            type="text"
            value={formFieldsValues.arabicDisplayName}
            onChange={event =>
              handleTextInputFieldChange(
                stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.arabicDisplayName,
                event,
              )
            }
            name={stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.arabicDisplayName}
          />
          {formFieldsValidation.arabicDisplayName === addLabFormValidationErrorType.empty && (
            <>
              <SectionDivider gap={4} />
              <FormValidationError>
                {stringsData.vendorDetailsContent.vendorDetailsFormFields.formEmptyFieldError(
                  stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.arabicDisplayName,
                )}
              </FormValidationError>
            </>
          )}
        </FormFieldWrapper>
        {/* Address */}
        <FormFieldWrapper span={3}>
          <FormLabel>{`${stringsData.vendorDetailsContent.vendorDetailsFormFields.getFormFieldLabel(
            stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.englishAddress,
          )}*`}</FormLabel>
          <SectionDivider gap={4} />
          <InputField
            type="text"
            value={formFieldsValues.englishAddress}
            onChange={event =>
              handleTextInputFieldChange(
                stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.englishAddress,
                event,
              )
            }
            name={stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.englishAddress}
          />
          {formFieldsValidation.englishAddress === addLabFormValidationErrorType.empty && (
            <>
              <SectionDivider gap={4} />
              <FormValidationError>
                {stringsData.vendorDetailsContent.vendorDetailsFormFields.formEmptyFieldError(
                  stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.englishAddress,
                )}
              </FormValidationError>
            </>
          )}
        </FormFieldWrapper>
        <FormFieldWrapper span={3}>
          <FormLabel>{`${stringsData.vendorDetailsContent.vendorDetailsFormFields.getFormFieldLabel(
            stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.arabicAddress,
          )}*`}</FormLabel>
          <SectionDivider gap={4} />
          <InputField
            type="text"
            value={formFieldsValues.arabicAddress}
            onChange={event =>
              handleTextInputFieldChange(
                stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.arabicAddress,
                event,
              )
            }
            name={stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.arabicAddress}
          />
          {formFieldsValidation.arabicAddress === addLabFormValidationErrorType.empty && (
            <>
              <SectionDivider gap={4} />
              <FormValidationError>
                {stringsData.vendorDetailsContent.vendorDetailsFormFields.formEmptyFieldError(
                  stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.arabicAddress,
                )}
              </FormValidationError>
            </>
          )}
        </FormFieldWrapper>
        {/* location */}
        <FormFieldWrapper span={3}>
          <FormLabel>{`${stringsData.vendorDetailsContent.vendorDetailsFormFields.getFormFieldLabel(
            stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.location,
          )}*`}</FormLabel>
          <SectionDivider gap={4} />
          <AddOrEditVendorComponentLocationInputsWrapper>
            <AddOrEditVendorComponenSingleLocationWrapper>
              <InputField
                type="text"
                value={formFieldsValues.lat}
                onChange={event =>
                  handleTextInputFieldChange(
                    stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.lat,
                    event,
                  )
                }
                extendStyle={extendInputFieldStyle}
                leadingText={stringsData.vendorDetailsContent.vendorDetailsFormFieldsUnits.getFormFieldUnit(
                  stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.lat,
                )}
                name={stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.lat}
              />
              {formFieldsValidation.lat === addLabFormValidationErrorType.empty && (
                <>
                  <SectionDivider gap={4} />
                  <FormValidationError>
                    {stringsData.vendorDetailsContent.vendorDetailsFormFields.formEmptyFieldError(
                      stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.lat,
                    )}
                  </FormValidationError>
                </>
              )}
              {formFieldsValidation.lat === addLabFormValidationErrorType.wrong && (
                <>
                  <SectionDivider gap={4} />
                  <FormValidationError>
                    {stringsData.vendorDetailsContent.vendorDetailsFormFields.formWrongFieldErrorText(
                      stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.lat,
                    )}
                  </FormValidationError>
                </>
              )}
            </AddOrEditVendorComponenSingleLocationWrapper>
            <AddOrEditVendorComponenSingleLocationWrapper>
              <InputField
                type="text"
                value={formFieldsValues.long}
                onChange={event =>
                  handleTextInputFieldChange(
                    stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.long,
                    event,
                  )
                }
                extendStyle={extendInputFieldStyle}
                leadingText={stringsData.vendorDetailsContent.vendorDetailsFormFieldsUnits.getFormFieldUnit(
                  stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.long,
                )}
                name={stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.long}
              />
              {formFieldsValidation.long === addLabFormValidationErrorType.empty && (
                <>
                  <SectionDivider gap={4} />
                  <FormValidationError>
                    {stringsData.vendorDetailsContent.vendorDetailsFormFields.formEmptyFieldError(
                      stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.long,
                    )}
                  </FormValidationError>
                </>
              )}
              {formFieldsValidation.long === addLabFormValidationErrorType.wrong && (
                <>
                  <SectionDivider gap={4} />
                  <FormValidationError>
                    {stringsData.vendorDetailsContent.vendorDetailsFormFields.formWrongFieldErrorText(
                      stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.long,
                    )}
                  </FormValidationError>
                </>
              )}
            </AddOrEditVendorComponenSingleLocationWrapper>
          </AddOrEditVendorComponentLocationInputsWrapper>
        </FormFieldWrapper>
        {/* Contact Person */}
        <FormFieldWrapper span={6}>
          <FormLabel>{`${stringsData.vendorDetailsContent.vendorDetailsFormFields.getFormFieldLabel(
            stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.contactPerson,
          )}*`}</FormLabel>
          <SectionDivider gap={4} />
          <InputField
            type="text"
            value={formFieldsValues.contactPerson}
            onChange={event =>
              handleTextInputFieldChange(
                stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.contactPerson,
                event,
              )
            }
            name={stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.contactPerson}
          />
          {formFieldsValidation.contactPerson === addLabFormValidationErrorType.empty && (
            <>
              <SectionDivider gap={4} />
              <FormValidationError>
                {stringsData.vendorDetailsContent.vendorDetailsFormFields.formEmptyFieldError(
                  stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.contactPerson,
                )}
              </FormValidationError>
            </>
          )}
        </FormFieldWrapper>
        {/* Email */}
        <FormFieldWrapper span={3}>
          <FormLabel>{`${stringsData.vendorDetailsContent.vendorDetailsFormFields.getFormFieldLabel(
            stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.email,
          )}*`}</FormLabel>
          <SectionDivider gap={4} />
          <InputField
            type="text"
            value={formFieldsValues.email}
            onChange={event =>
              handleTextInputFieldChange(
                stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.email,
                event,
              )
            }
            name={stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.email}
          />
          {formFieldsValidation.email === addLabFormValidationErrorType.empty && (
            <>
              <SectionDivider gap={4} />
              <FormValidationError>
                {stringsData.vendorDetailsContent.vendorDetailsFormFields.formEmptyFieldError(
                  stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.email,
                )}
              </FormValidationError>
            </>
          )}
          {formFieldsValidation.email === addLabFormValidationErrorType.wrong && (
            <>
              <SectionDivider gap={4} />
              <FormValidationError>
                {stringsData.vendorDetailsContent.vendorDetailsFormFields.formWrongFieldErrorText(
                  stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.email,
                )}
              </FormValidationError>
            </>
          )}
        </FormFieldWrapper>
        {/* phone */}
        <FormFieldWrapper span={3}>
          <FormLabel>{`${stringsData.vendorDetailsContent.vendorDetailsFormFields.getFormFieldLabel(
            stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.phone,
          )}*`}</FormLabel>
          <SectionDivider gap={4} />
          <InputField
            type="text"
            value={formFieldsValues.phone}
            onChange={event =>
              handleTextInputFieldChange(
                stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.phone,
                event,
              )
            }
            name={stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.phone}
          />
          {formFieldsValidation.phone === addLabFormValidationErrorType.empty && (
            <>
              <SectionDivider gap={4} />
              <FormValidationError>
                {stringsData.vendorDetailsContent.vendorDetailsFormFields.formEmptyFieldError(
                  stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.phone,
                )}
              </FormValidationError>
            </>
          )}
          {formFieldsValidation.phone === addLabFormValidationErrorType.wrong && (
            <>
              <SectionDivider gap={4} />
              <FormValidationError>
                {stringsData.vendorDetailsContent.vendorDetailsFormFields.formWrongFieldErrorText(
                  stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.phone,
                )}
              </FormValidationError>
            </>
          )}
        </FormFieldWrapper>
        {/* Delivery */}
        <FormFieldWrapper span={2}>
          <FormLabel>{`${stringsData.vendorDetailsContent.vendorDetailsFormFields.getFormFieldLabel(
            stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.deliveryRadius,
          )}*`}</FormLabel>
          <SectionDivider gap={4} />
          <InputField
            type="text"
            value={formFieldsValues.deliveryRadius}
            onChange={event =>
              handleTextInputFieldChange(
                stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.deliveryRadius,
                event,
              )
            }
            leadingText={stringsData.vendorDetailsContent.vendorDetailsFormFieldsUnits.getFormFieldUnit(
              stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.deliveryRadius,
            )}
            name={stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.deliveryRadius}
          />
          {formFieldsValidation.deliveryRadius === addLabFormValidationErrorType.empty && (
            <>
              <SectionDivider gap={4} />
              <FormValidationError>
                {stringsData.vendorDetailsContent.vendorDetailsFormFields.formEmptyFieldError(
                  stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.deliveryRadius,
                )}
              </FormValidationError>
            </>
          )}
        </FormFieldWrapper>
        <FormFieldWrapper span={2}>
          <FormLabel>{`${stringsData.vendorDetailsContent.vendorDetailsFormFields.getFormFieldLabel(
            stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.partnershipDeliveryRadius,
          )}*`}</FormLabel>
          <SectionDivider gap={4} />
          <InputField
            type="text"
            value={formFieldsValues.partnershipDeliveryRadius}
            onChange={event =>
              handleTextInputFieldChange(
                stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys
                  .partnershipDeliveryRadius,
                event,
              )
            }
            leadingText={stringsData.vendorDetailsContent.vendorDetailsFormFieldsUnits.getFormFieldUnit(
              stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.partnershipDeliveryRadius,
            )}
            name={
              stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.partnershipDeliveryRadius
            }
          />
          {formFieldsValidation.partnershipDeliveryRadius ===
            addLabFormValidationErrorType.empty && (
            <>
              <SectionDivider gap={4} />
              <FormValidationError>
                {stringsData.vendorDetailsContent.vendorDetailsFormFields.formEmptyFieldError(
                  stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys
                    .partnershipDeliveryRadius,
                )}
              </FormValidationError>
            </>
          )}
        </FormFieldWrapper>
        <FormFieldWrapper span={2}>
          <FormLabel>{`${stringsData.vendorDetailsContent.vendorDetailsFormFields.getFormFieldLabel(
            stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.deliveryCharge,
          )}*`}</FormLabel>
          <SectionDivider gap={4} />
          <InputField
            type="text"
            value={formFieldsValues.deliveryCharge}
            onChange={event =>
              handleTextInputFieldChange(
                stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.deliveryCharge,
                event,
              )
            }
            leadingText={stringsData.vendorDetailsContent.vendorDetailsFormFieldsUnits.getFormFieldUnit(
              stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.deliveryCharge,
            )}
            name={stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.deliveryCharge}
          />
          {formFieldsValidation.deliveryCharge === addLabFormValidationErrorType.empty && (
            <>
              <SectionDivider gap={4} />
              <FormValidationError>
                {stringsData.vendorDetailsContent.vendorDetailsFormFields.formEmptyFieldError(
                  stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.deliveryCharge,
                )}
              </FormValidationError>
            </>
          )}
        </FormFieldWrapper>
        {/* adminNote */}
        <FormFieldWrapper span={6}>
          <FormLabel>
            {stringsData.vendorDetailsContent.vendorDetailsFormFields.getFormFieldLabel(
              stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.adminNote,
            )}
          </FormLabel>
          <SectionDivider gap={4} />
          <InputField
            type="text"
            value={formFieldsValues.adminNote}
            onChange={event =>
              handleTextInputFieldChange(
                stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.adminNote,
                event,
              )
            }
            name={stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.adminNote}
          />
          {formFieldsValidation.adminNote === addLabFormValidationErrorType.empty && (
            <>
              <SectionDivider gap={4} />
              <FormValidationError>
                {stringsData.vendorDetailsContent.vendorDetailsFormFields.formEmptyFieldError(
                  stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.adminNote,
                )}
              </FormValidationError>
            </>
          )}
        </FormFieldWrapper>
        {/* Is Active */}
        <ActivityFormFieldWrapper>
          <FormLabel>{`${stringsData.vendorDetailsContent.vendorDetailsFormFields.getFormFieldLabel(
            stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.isActive,
          )}*`}</FormLabel>
          <ToggleBtn
            onChange={event =>
              handleCheckboxFieldChange(
                stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.isActive,
                event,
              )
            }
            value={formFieldsValues.isActive}
            name={stringsData.vendorDetailsContent.vendorDetailsFormFieldKeys.isActive}
          />
        </ActivityFormFieldWrapper>
      </FormGrid>
    </FormWrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};
export default AddOrEditVendorComponent;

AddOrEditVendorComponent.propTypes = {
  stringsData: PropTypes.shape({
    vendorDetailsContent: PropTypes.shape({
      vendorDetailsFormFields: PropTypes.shape({
        getFormFieldLabel: PropTypes.func,
        formEmptyFieldError: PropTypes.func,
        formWrongFieldErrorText: PropTypes.func,
      }),
      vendorDetailsFormFieldsUnits: PropTypes.shape({
        getFormFieldUnit: PropTypes.func,
      }),
      vendorDetailsFormFieldKeys: PropTypes.shape({
        englishName: PropTypes.string,
        englishDisplayName: PropTypes.string,
        englishAddress: PropTypes.string,
        arabicName: PropTypes.string,
        arabicDisplayName: PropTypes.string,
        arabicAddress: PropTypes.string,
        location: PropTypes.string,
        lat: PropTypes.string,
        long: PropTypes.string,
        contactPerson: PropTypes.string,
        email: PropTypes.string,
        phone: PropTypes.string,
        deliveryRadius: PropTypes.string,
        partnershipDeliveryRadius: PropTypes.string,
        deliveryCharge: PropTypes.string,
        adminNote: PropTypes.string,
        isActive: PropTypes.string,
        pharmacyType: PropTypes.string,
      }),
    }),
  }).isRequired,
  formFieldsValues: PropTypes.shape({
    englishName: PropTypes.string,
    englishDisplayName: PropTypes.string,
    englishAddress: PropTypes.string,
    arabicName: PropTypes.string,
    arabicDisplayName: PropTypes.string,
    arabicAddress: PropTypes.string,
    lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    long: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    contactPerson: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    deliveryRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    partnershipDeliveryRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    deliveryCharge: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    adminNote: PropTypes.string,
    isActive: PropTypes.bool,
    pharmacyTypeId: PropTypes.number,
  }).isRequired,
  setFormFieldsValues: PropTypes.func.isRequired,
  formFieldsValidation: PropTypes.shape({
    englishName: PropTypes.number,
    englishDisplayName: PropTypes.number,
    englishAddress: PropTypes.number,
    arabicName: PropTypes.number,
    arabicDisplayName: PropTypes.number,
    arabicAddress: PropTypes.number,
    lat: PropTypes.number,
    long: PropTypes.number,
    contactPerson: PropTypes.number,
    email: PropTypes.number,
    phone: PropTypes.number,
    deliveryRadius: PropTypes.number,
    partnershipDeliveryRadius: PropTypes.number,
    deliveryCharge: PropTypes.number,
    adminNote: PropTypes.number,
    isActive: PropTypes.number,
    pharmacyTypeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired,
  vendorTypes: PropTypes.arrayOf([]),
  handleDropDownFieldChange: PropTypes.func.isRequired,
};

AddOrEditVendorComponent.defaultProps = {
  vendorTypes: [],
};
